import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBox1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      d='m12 1.5 9.093 5.25v10.5L12 22.5l-9.093-5.25V6.75z'
      opacity={0.2}
    />
    <path
      stroke='#fff'
      strokeWidth={2}
      d='M10.5 2.366a3 3 0 0 1 3 0l6.093 3.518a3 3 0 0 1 1.5 2.598v7.036a3 3 0 0 1-1.5 2.598L13.5 21.634a3 3 0 0 1-3 0l-6.093-3.518a3 3 0 0 1-1.5-2.598V8.482a3 3 0 0 1 1.5-2.598z'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeWidth={2}
      d='M12 12 3.665 7.188M12 12v9.625M12 12l8.336-4.812'
    />
    <path
      fill='#fff'
      d='M15.763 12.444V9.827L6.95 4.738l1.979-1.167 8.835 5.102v3.077c0 .573-.306 1.102-.802 1.387a.8.8 0 0 1-1.198-.694'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBox1)
export default ForwardRef
